/**
 * First-touch marketing attribution.
 *
 * Ad parameters only exist on the landing URL. A visitor who reads two pages
 * before filling in the form would otherwise reach Clio as "Direct", so the
 * first view of the session is captured and reused for every later submission.
 */

const KEY = "gw_attribution";

const PARAM_FIELDS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "wbraid",
  "gbraid",
  "fbclid",
  "msclkid",
];

/** Call once on app start. Safe to call again; the first touch wins. */
export function captureAttribution() {
  if (typeof window === "undefined") return;
  try {
    if (window.sessionStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const data = {
      referrer: document.referrer || "",
      landing_page: window.location.href,
      captured_at: new Date().toISOString(),
    };
    PARAM_FIELDS.forEach((field) => {
      const value = params.get(field);
      if (value) data[field] = value;
    });
    window.sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch (_) {
    // Private mode or blocked storage: attribution is a nice-to-have,
    // never a reason for the form to misbehave.
  }
}

/** GA4 client id, so a lead can be tied back to its session in Analytics. */
function gaClientId() {
  try {
    const match = document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/);
    return match ? match[1] : "";
  } catch (_) {
    return "";
  }
}

/** Everything known about how this visitor arrived, for the lead payload. */
export function readAttribution() {
  let stored = {};
  try {
    stored = JSON.parse(window.sessionStorage.getItem(KEY) || "{}");
  } catch (_) {
    stored = {};
  }
  return {
    ...stored,
    page_url: typeof window !== "undefined" ? window.location.href : "",
    page_language:
      typeof document !== "undefined"
        ? document.documentElement.lang || "en"
        : "en",
    ga_client_id: gaClientId(),
  };
}
